(() => {
  const labels = /^(Artikelzustand|Hersteller|Leistung|Spannung|Starterleistung|Zähne|Sonstige Originalnummern)\s*:\s*(.*)$/i;
  function normalize(root) {
    if (root.dataset.alsNormalized) return;
    root.dataset.alsNormalized = 'true';
    const rows = [];
    const removals = [];
    for (const p of Array.from(root.querySelectorAll('p'))) {
      if (p.closest('table') || p.querySelector('img,a,video')) continue;
      const lines = p.innerHTML.split(/<br\s*\/?\s*>/i).map(html => {
        const temp = document.createElement('div'); temp.innerHTML = html;
        return temp.textContent.replace(/\u00a0/g,' ').trim();
      }).filter(Boolean);
      if (!lines.length || !lines.every(line => labels.test(line))) continue;
      const parsed = lines.map(line => {const m=line.match(labels);return [m[1],m[2]];});
      let valid = true;
      for (const row of parsed) {
        if (!row[1] && row[0].toLowerCase() === 'sonstige originalnummern') {
          let next = p.nextElementSibling;
          while (next && next.tagName === 'P' && !next.textContent.trim() && !next.querySelector('img')) next = next.nextElementSibling;
          if (next && next.tagName === 'TABLE') {
            row[1] = Array.from(next.rows).map(tr => Array.from(tr.cells).map(td => td.textContent.trim()).filter(Boolean).join(' ')).filter(Boolean).join('\n');
            row.push(next);
          } else valid = false;
        } else if (!row[1]) valid = false;
      }
      if (valid) {rows.push(...parsed);removals.push(p,...parsed.map(r=>r[2]).filter(Boolean));}
    }
    if (!rows.length) return;
    const table = document.createElement('table'); table.className='als-legacy-specs';
    const caption=table.createCaption();caption.textContent='Technische Daten';
    const body=table.createTBody();
    const used=new Set();
    for(const [label,value] of rows) {
      const key=label.toLowerCase();
      if(used.has(key)) continue;
      used.add(key);
      const tr=body.insertRow(); const th=document.createElement('th');
      th.scope='row';th.textContent=label;tr.append(th);
      const td=tr.insertCell();td.textContent=value;
    }
    removals[0].before(table);removals.forEach(el=>el.remove());
    for(const p of root.querySelectorAll('p')) {
      if(!p.textContent.replace(/\u00a0/g,' ').trim() && !p.querySelector('img,video,iframe,input')) p.remove();
    }
    const details=root.closest('.product-details');
    if(details) for(const other of details.querySelectorAll('.als-specs table')) {
      for(const tr of Array.from(other.rows)) {
        const th=tr.querySelector('th');
        if(th && used.has(th.textContent.trim().replace(/:$/,'').toLowerCase())) tr.remove();
      }
      if(!other.querySelector('tbody tr')) other.remove();
    }
  }
  const run = () => document.querySelectorAll('.als-legacy-description').forEach(normalize);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();